import qs from 'qs';
import { AxiosRequestConfig } from 'axios';

export const requestParamsSerializer: AxiosRequestConfig['paramsSerializer'] = params =>
    qs.stringify(params, { arrayFormat: 'comma' });

export const requestParamsSerializerNoIndices: AxiosRequestConfig['paramsSerializer'] = params =>
    qs.stringify(params, { indices: false });
